import React, { useState  } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import CryptoJS from "crypto-js";
import PageTitle from "../../../components/Structure/Title/PageTitle";
import SectionTitle from "../../../components/Structure/Title/SectionTitle";
import CarePlanElements from "../components/creation/CarePlanElements";
import CarePlanTemplate from "../components/creation/CarePlanTemplate";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

const SECRET_KEY = "mySecretKey123";

export default function CarePlanCreation() {
  const { t } = useTranslation();
  const { patientId } = useParams();
  const [showCarePlan, setShowCarePlan] = useState(true);
  const [showCarePlanTemplate, setShowCarePlanTemplate] = useState(false);
  const navigate = useNavigate();

  const handleCancel = () => {
    navigate(`/Careplan`);
  };

  let decryptedId = null;
  let isValid = false;

  try {
    // Desencriptar
    const bytes = CryptoJS.AES.decrypt(decodeURIComponent(patientId), SECRET_KEY);
    decryptedId = bytes.toString(CryptoJS.enc.Utf8);
    // Validar que sea numérico
    if (!isNaN(decryptedId) && decryptedId.trim() !== "") {
      isValid = true;
    }
  } catch (error) {
    console.error("Error al desencriptar el ID:", error);
  }

  // Cuando el usuario pulse "Crear Care Plan" en CarePlanElements,
  // cambiamos a true 'showCarePlanTemplate'.
  const handleCreatePlan = () => {
    setShowCarePlanTemplate(true);
  };

  return (

    <Box sx={{ width: "100%", margin: "auto", mt: 4, p: 3 }}>
      {isValid ? (
        <>
          {/* Título */}
          <PageTitle translationKey="CarePlan.createCarePlanHdr.title" />

        <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
          <Button
            variant="outlined"
            color="error"
            startIcon={<ArrowBackIcon />}
            onClick={handleCancel}
          >
            {t("CarePlan.createCarePlanHdr.CancelCreation")}
          </Button>
        </Box>

          {/* Subtítulo */}
          <Box sx={{ mt: 5 }}>
            <SectionTitle translationKey="CarePlan.createCarePlanHdr.subtitle" />
          </Box>

          {/* 1) CarePlanElements: se muestra solo si showCarePlan==true y showCarePlanTemplate==false */}
          {showCarePlan && !showCarePlanTemplate && (
            <CarePlanElements
            patientId={decryptedId}
            onCreatePlan={handleCreatePlan}
          />
          )}

          {/* 2) CarePlanTemplate: se muestra cuando showCarePlanTemplate==true */}
          {showCarePlan && showCarePlanTemplate && <CarePlanTemplate />}

        </>
      ) : (
        // Acceso denegado
        <>
          <Typography
            variant="h4"
            sx={{ fontWeight: "bold", textAlign: "center", color: "red" }}
          >
            Access Denied
          </Typography>
          <Typography variant="body1" sx={{ textAlign: "center", color: "gray" }}>
            You do not have permission to access this page or the patient ID is invalid.
          </Typography>
        </>
      )}
    </Box>
  );
}
